import React from 'react';
import clsx from 'clsx';

type RadioOption = {
  id: string | boolean;
  label: string;
  disabled?: boolean;
};

type RadioGroupProps = {
  name?: string;
  options: RadioOption[];
  value?: string | boolean;
  onChange?: (value: string | boolean) => void;
  label?: string;
  disabled?: boolean;
  direction?: 'row' | 'column';
  className?: string;
  labelPosition?: 'left' | 'right';
  itemClass?: string;
  itemLabelClass?: string;
  labelClass?: string;
};

export const RadioGroup: React.FC<RadioGroupProps> = ({
  name = '',
  options,
  value,
  onChange,
  label,
  disabled = false,
  direction = 'column',
  className = 'gap-2',
  labelPosition = 'right',
  itemClass = 'gap-2 w-full',
  itemLabelClass = 'text-medium',
  labelClass = 'text-sm font-medium text-mainText',
}) => {
  const isColumn = direction === 'column';

  return (
    <div className={clsx('flex flex-col ', className)}>
      {label && <label className={clsx('mb-1', labelClass)}>{label}</label>}

      <div
        className={clsx({
          'flex flex-col max-h-60 overflow-y-auto border-bottom border-border rounded-md divide-y divide-border':
            isColumn,
          'flex gap-4': !isColumn,
        })}
      >
        {options.map(option => (
          <label
            key={String(option.id)}
            className={clsx(
              'flex items-center px-4 py-2',
              labelPosition === 'left' ? 'flex-row-reverse' : 'flex-row',
              itemClass,
              (disabled || option.disabled) && 'opacity-50 cursor-not-allowed'
            )}
          >
            <input
              type="radio"
              name={name}
              value={String(option.id)}
              checked={value === option.id}
              disabled={disabled || option.disabled}
              onChange={() => onChange?.(option.id)}
              className="w-8 h-8 text-primary border border-border rounded-full focus:ring-0 shrink-0"
            />
            <span
              className={clsx(
                'text-mainText truncate max-w-full overflow-hidden',
                itemLabelClass
              )}
            >
              {option.label}
            </span>
          </label>
        ))}
      </div>
    </div>
  );
};
